var map = {
	"./directives/templates/addFriends.html": 6115,
	"./directives/templates/chatAbuseReport.html": 3474,
	"./directives/templates/chatAvatarHeadshot.html": 4947,
	"./directives/templates/chatBar.html": 3540,
	"./directives/templates/chatBase.html": 4497,
	"./directives/templates/chatDialog.html": 3355,
	"./directives/templates/chatGameIcon.html": 7709,
	"./directives/templates/chatGroupDialog.html": 9816,
	"./directives/templates/chatPlaceholder.html": 4120,
	"./directives/templates/confirmNegativeAction.html": 8895,
	"./directives/templates/conversationTitle.html": 2791,
	"./directives/templates/conversationTitleEditor.html": 6465,
	"./directives/templates/createChatGroup.html": 4748,
	"./directives/templates/details.html": 9837,
	"./directives/templates/dialogHeader.html": 7905,
	"./directives/templates/dialogMinimize.html": 3528,
	"./directives/templates/displayMessage.html": 2449,
	"./directives/templates/gamesList.html": 954,
	"./directives/templates/linkCard.html": 1651,
	"./directives/templates/pendingState.html": 162,
	"./directives/templates/selectFriends.html": 4310,
	"./directives/templates/systemMessage.html": 3812,
	"./directives/templates/userConversationInfo.html": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4850;